import type { FaireProductEntity } from "../../entity_types/product";

export const p_uekhxy7gmg: FaireProductEntity = {
  token: "p_uekhxy7gmg",
  type: "product",
  name: "Star Prong-Set Studs S925 Rhodium-Plated Sparkling S5P138",
  brandToken: "b_vzcwf2s2c8",
  brandName: "alberalkirk",
  imageUrl:
    "https://cdn.faire.com/fastly/a0a1c6b5e882db00a57a7988d1b3a1a088d6a43d9fc87edce7dc882d25983c93.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/562eb598f58ac434fb6e3e086bd5817e897742963a75b543314d241cfe16e9ed.jpeg",
    "https://cdn.faire.com/fastly/33e5fcc5abb84335efee1a142310bb40fc23f649c3eb20a6f1c0c9b864723fce.jpeg",
    "https://cdn.faire.com/fastly/0ebc7ee8de693fafd3be3a105d4db0eb26db4af9da987fa0a3ee729219c9dce2.jpeg",
    "https://cdn.faire.com/fastly/9d8a96c9bc939867d5a0d517c696d9f109336c83e41b6f4dd990b7dd4d07a413.jpeg",
  ],
  priceDollars: 7.52,
  description:
    "Material: \n * Sterling Silver (S925) \n\n Weight: \n * 0.7g/pair \n\n Feature: \n * Five-Point Star Silhouette \n * Prong-Set Cubic Zirconia \n * Rhodium-Plated Brilliance \n * Hypoallergenic Steel Posts \n * Ultra-Lightweight Profile \n\n Note: \n * Clean with silver polishing cloth \n * Store in anti-tarnish pouch \n * Avoid sulfur & cosmetics ",
  tags: [],
  msrpDollars: 15.05,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:22.788Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
